/**
 * Converts Planner feedback settings to Loop feedback policy
 * @param feedbackSettings Feedback settings object from Planner
 * @returns Feedback policy object for Loop
 */ export const convertTenantFeedbackSettingsToFeedbackPolicy = (feedbackSettings)=>{
    if (!feedbackSettings) {
        return undefined;
    }
    return {
        connectedOfficeExperiencesEnabled: feedbackSettings.allowConnectedOfficeExperiences,
        emailEnabled: feedbackSettings.allowFollowUp,
        screenshotEnabled: feedbackSettings.allowScreenshot,
        sendFeedbackEnabled: feedbackSettings.allowFeedback,
        contentEnabled: feedbackSettings.allowLogCollection,
        sendCopilotFeedbackEnabled: feedbackSettings.allowCopilotFeedback
    };
};
/**
 * Get the policy payload for the given policy id.
 * @param policyId The policy id to get the policy payload for.
 * @param tenantFeedbackSettings The tenant feedback settings object.
 * @returns The policy payload for the given policy id.
 */ export const getLoopPolicyPayload = (policyId, tenantFeedbackSettings)=>{
    const policyDetails = tenantFeedbackSettings?.getPolicyDetails(policyId) ?? null;
    return policyDetails?.value ? {
        value: policyDetails.value
    } : undefined;
};
